import React from "react";
import { BrowserRouter as Router, Switch, Redirect } from "react-router-dom";
import { Route } from "react-router-dom";

import { Login, Signup, ForgotPassword, AbonnementStatus, ReinitPassword, Message, ConfirmedCompte, AbonnementInconnu, EtatAbonnement, EtatAbonAdmin } from "../auth/";
import { Kids, AddKid } from "../kids";
import AllRoutes from "../kids/kids-list/AllRoutes";
import { PrivateRoute, AuthRoute } from "../../components/";
import history from './history';
import Routes from './Routes';
import AllreadyConfirmed from "../auth/login/AllreadyConfirmed";
import TokenIntrouvable from "../auth/login/TokenIntrouvable";


const App = props => {
  console.log('vvvvvvvvvvvvvvvv222222222222')
  return (
    <Router history={history} basename={process.env.REACT_APP_ROUTER_BASE || ''} >
      <Switch>

        <PrivateRoute exact path="/enfants" component={AllRoutes} />
        <PrivateRoute exact path="/" component={AllRoutes} />
        <PrivateRoute path="/enfant" component={AllRoutes} />
        <PrivateRoute path="/communaute" component={AllRoutes} />
        <PrivateRoute path="/creche" component={AllRoutes} />
        <PrivateRoute path="/staff" component={AllRoutes} />
        <PrivateRoute path="/evenements" component={AllRoutes} />
        <PrivateRoute path="/menus" component={AllRoutes} />
        <Route path="/compte/confirmed" component={ConfirmedCompte} />


        <Route path="/compte/allready-confirmed" component={AllreadyConfirmed} />
        <Route path="/compte/token-introuvable" component={TokenIntrouvable} />
        <PrivateRoute path="/compte" component={AllRoutes} />




        <AuthRoute path="/login" component={Login} />
        <Route path="/forgot-password" component={ForgotPassword} />
        <Route path="/message" component={Message} />
        <Route path="/api/compte/reset-password" component={ReinitPassword} />






        <Route path="/etat-abonnement-admin" component={EtatAbonAdmin} />
        <Route path="/etat-abonnement" component={EtatAbonnement} />
        <Route path="/abonnement-inconnu" component={AbonnementInconnu} />
        <Route path="/update-abonnement" component={AbonnementStatus} />


        <AuthRoute exact path="/signup" component={Signup} />
      </Switch>

    </Router>
  );
}

export default App;
